<template>
  <div class="component_card">
    <div class="column columns redeem_form mw100">
      <div class="column">
        <div class="column tal_c">
          <div class="column upper fat">
            {{ $t("msg.confirm_withdraw") }}
          </div>

          <div class="column" v-if="selectedBlue">
            <p class="fat amount_withdraw">
              {{ $t("msg.amount_revice_withdraw") }}
              <span v-if="withdrawData.amount">{{ withdrawData.amount ? withdrawData.amount.toFixed(6) : '' }}</span>
              BLUE 
              <br> ({{ $t("msg.amount_revice_withdraw_fee") }} {{ withdrawData.fee ? withdrawData.fee.toFixed(6) : '0.00' }} BLUE)
            </p>
          </div>

          <div class="column" v-else>
            <p class="fat amount_withdraw">
              {{ $t("msg.amount_revice_withdraw") }}
              <span v-if="withdrawData.amount">{{ withdrawData.amount ? withdrawData.amount.toFixed(2) : '' }}</span>
              USDT 
              <br>
              ({{ $t("msg.amount_revice_withdraw_fee") }} {{ withdrawData.fee ? withdrawData.fee.toFixed(2) : '2' }} USDT)
            </p>
          </div>
          
          <div class="column email-info">
            <p v-html="$t('msg.info_redeem_address_step_4')"></p>
            <p class="withdraw-address-final-step">{{ withdrawData.address }}</p>
          </div>
          
          <div class="column email-info">
            <p v-html="$t('msg.info_redeem_email_step_4')"></p>
          </div>
          <div class="column">
            <p v-html="$t('msg.info_withdraw_step_4')"></p>
          </div>
          <div class="column upper">
            <router-link to="/transactions/withdraw">{{
              $t("msg.view_status")
            }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: ["withdrawData", "selectedBlue"],
  created() {},
  mounted() {},
  data: () => ({}),
  components: {},
  methods: {},
  computed: {
    ...mapGetters([]),
  },
  watch: {},
};
</script>




// WEBPACK FOOTER //
// src/components/private/services/withdraw_steps/WithdrawStep4.vue